// import React from "react";
// import { Tooltip, Button, message } from "antd";
// import { PhoneOutlined, WhatsAppOutlined } from "@ant-design/icons";
// import "./floatingContactButtons.css";

// const FloatingContactButtons = () => {
//   const handleCallingButton = (e) => {
//     const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
//     if (!isMobile) {
//       e.preventDefault();
//       message.warning("Calling is only supported on mobile devices.");
//     }
//   };

//   return (
//     <div className="floating-contact-container">
//       <Tooltip title="Call us" placement="left">
//         <a href="tel:+045771575" onClick={handleCallingButton}>
//           <Button
//             type="primary"
//             shape="circle"
//             icon={<PhoneOutlined />}
//             size="large"
//             style={{
//               backgroundColor: "#2196F3",
//               borderColor: "#2196F3",
//               fontSize: "24px",
//               width: "50px",
//               height: "50px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           />
//         </a>
//       </Tooltip>
//       <Tooltip title="Chat on WhatsApp" placement="left">
//         <a
//           href="https://wa.me/+045771575"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           <Button
//             type="primary"
//             shape="circle"
//             icon={<WhatsAppOutlined />}
//             size="large"
//             style={{
//               backgroundColor: "#25D366",
//               borderColor: "#25D366",
//               fontSize: "24px",
//               width: "50px",
//               height: "50px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           />
//         </a>
//       </Tooltip>
//     </div>
//   );
// };

// export default FloatingContactButtons;

import React, { useEffect, useState } from "react";
import { Tooltip, Button, message } from "antd";
import { PhoneOutlined, WhatsAppOutlined } from "@ant-design/icons";
import "./floatingContactButtons.css";

const FloatingContactButtons = () => {
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;

      setIsAtBottom(scrollTop + windowHeight >= fullHeight - 5);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleCallingButton = (e) => {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (!isMobile) {
      e.preventDefault();
      message.warning("Calling is only supported on mobile devices.");
    }
  };

  return (
    <>
      {!isAtBottom && (
<div className={`floating-contact-container ${isAtBottom ? "fade-out" : "fade-in"}`}>
          <Tooltip title="Call us" placement="left">
            <a href="tel:+045771575" onClick={handleCallingButton}>
              <Button
                type="primary"
                shape="circle"
                icon={<PhoneOutlined />}
                size="large"
                style={{
                  backgroundColor: "#2196F3",
                  borderColor: "#2196F3",
                  fontSize: "24px",
                  width: "50px",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            </a>
          </Tooltip>
          <Tooltip title="Chat on WhatsApp" placement="left">
            <a
              href="https://wa.me/+045771575"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                type="primary"
                shape="circle"
                icon={<WhatsAppOutlined />}
                size="large"
                style={{
                  backgroundColor: "#25D366",
                  borderColor: "#25D366",
                  fontSize: "24px",
                  width: "50px",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            </a>
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default FloatingContactButtons;
